import Vue from 'vue';

import { calculateDeliveryTimeForProduct } from '@/helper/functions';

function sortLevel3(items, sort) {
  if (sort.name === '__hasProduct') {
    const ret = [];
    const ret2 = [];
    items.forEach(function(product) {
      var addItem = 0;
      if (product.id === sort.id) {
        addItem = 1;
      } else if (product.manufacturer === sort.manufacturer) {
        if (addItem === 0) {
          addItem = 2;
        }
      }

      if (addItem === 1) {
        ret.unshift(product);
      } else if (addItem === 2) {
        ret.push(product);
      } else {
        ret2.push(product);
      }
    });

    return ret.concat(ret2);
  } else if (sort.name === '__event') {
    if (!sort.onlyB2b || (sort.onlyB2b && sort.isB2b)) {
      const tags = sort.value.split(',');
      const ret = [];
      const ret2 = [];
      var i = 0;

      for (i = 0; i < tags.length; ++i) {
        ret.push([]);
      }
      items.forEach(function(product) {
        var added = false;
        for (i = 0; i < tags.length; ++i) {
          if (product.event.includes(tags[i]) && !added) {
            ret[i].push(product);
            added = true;
          }
        }
        if (!added) {
          ret2.push(product);
        }
      });

      var final = [];
      for (i = 0; i < tags.length; ++i) {
        final = final.concat(ret[i]);
      }

      return final.concat(ret2);
    }
  }

  return items;
}

export const level3Store = {
  state: {
    listItemsLevel3: [],
    boxItemsLevel3: [],
    level3Helper: {},
    currentBox: {},
    level3Available: true,
    level3NotAvailable: false,
    level3Filter: {
      freeSearch: '',
      brands: [],
      categories: [],
      attributes: [],
      priceMin: 0,
      priceMax: 999999,
      useB2cPrices: false,
      sort: { name: '' },
      b2b: { qty: 0, time: -1 },
      adminDate: '',
      adminQty: ''
    },
    productIdToIdx: {}
  },
  getters: {
    getListItemsLevel3Filtered: (state, getters, rootState) => {
      const today = new Date();
      return getters.getListItemsLevel3.filter(function(product) {
        var valid = true;
        // var isBio = false;
        product.attributes.forEach(attribute => {
          if (
            state.level3Filter.brands.length > 0 &&
            attribute.name === 'Marke' &&
            !state.level3Filter.brands.includes(attribute.value[0])
          ) {
            valid = false;
          }
        });

        if (
          valid &&
          state.level3Filter.categories.length > 0 &&
          !state.level3Filter.categories.some(r => product.category.includes(r))
        ) {
          valid = false;
        }

        if (
          state.level3Filter.freeSearch !== '' &&
          valid &&
          !JSON.stringify(product)
            .toLowerCase()
            .includes(state.level3Filter.freeSearch.toLowerCase())
        ) {
          valid = false;
        }

        if (state.level3Filter.b2b.qty > 0 && valid) {
          if (
            !(
              product.custom_delivery_qty.allow_backorders === 'ja' ||
              (product.stock_status === 'instock' &&
                product.stock_quantity >= state.level3Filter.b2b.qty) ||
              new Date(product.release_date) > today
            )
          ) {
            valid = false;
          }
          if (
            state.level3Filter.b2b.qty < 20 &&
            product.stock_quantity < state.level3Filter.b2b.qty &&
            new Date(product.release_date) < today
          ) {
            valid = false;
          }
        }

        if (state.level3Filter.b2b.time === 0 && valid) {
          if (product.stock_quantity < state.level3Filter.b2b.qty) {
            valid = false;
          }
        }

        if (state.level3Filter.b2b.time > 0 && valid) {
          if (
            state.level3Filter.b2b.time <
            calculateDeliveryTimeForProduct(
              product,
              state.level3Filter.b2b.qty,
              getters.getDelTimeSettings
            )
          ) {
            valid = false;
          }
        }

        if (valid && rootState.global.adminMode && state.level3Filter.adminDate !== '' && state.level3Filter.adminDate.length === 11 && state.level3Filter.adminQty !== '' && state.level3Filter.adminQty.length > 1) {
          valid = false;
          if (product.sku in rootState.global.adminData.Gerichshain) {
            Object.keys(rootState.global.adminData.Gerichshain[product.sku]).forEach(date => {
              const d1 = new Date(date.split('.').reverse().join('-'));
              const d2 = new Date(state.level3Filter.adminDate.substr(1).split('.').reverse().join('-'));
              if (state.level3Filter.adminDate.substr(0, 1) === '<' && d1 <= d2) {
                if (state.level3Filter.adminQty.substr(0, 1) === '<' && rootState.global.adminData.Gerichshain[product.sku][date] <= parseInt(state.level3Filter.adminQty.substr(1))) {
                  valid = true;
                } else if (state.level3Filter.adminQty.substr(0, 1) === '>' && rootState.global.adminData.Gerichshain[product.sku][date] >= parseInt(state.level3Filter.adminQty.substr(1))) {
                  valid = true;
                }
              } else if (state.level3Filter.adminDate.substr(0, 1) === '>' && d1 >= d2) {
                if (state.level3Filter.adminQty.substr(0, 1) === '<' && rootState.global.adminData.Gerichshain[product.sku][date] <= parseInt(state.level3Filter.adminQty.substr(1))) {
                  valid = true;
                } else if (state.level3Filter.adminQty.substr(0, 1) === '>' && rootState.global.adminData.Gerichshain[product.sku][date] >= parseInt(state.level3Filter.adminQty.substr(1))) {
                  valid = true;
                }
              }
            });
          }
        }

        return valid;
      }).sort((a, b) => {
        if (state.level3Filter.categories.length > 0) {
          return state.level3Filter.categories.indexOf(b.category[0]) - state.level3Filter.categories.indexOf(a.category[0]);
        }

        return 0;
      });
    },
    getListItemsLevel3: (state, getters, rootState) => {
      const today = new Date();
      return sortLevel3(
        state.listItemsLevel3.filter(function(product) {
          if (
            product.stock_status === 'instock' ||
            ((product.stock_status === 'outofstock' || product.stock_status === 'onbackorder') &&
              product.custom_delivery_qty.allow_backorders === 'ja')
          ) {
            if (
              getters.getSelectedQty >= 20 ||
              product.stock_quantity >= getters.getSelectedQty ||
              new Date(product.release_date) > today
            ) {
              if (
                !(
                  product.custom_delivery_qty.allow_backorders === 'ja' ||
                  (product.stock_status === 'instock' &&
                    product.stock_quantity >= getters.getSelectedQty) ||
                  new Date(product.release_date) > today
                )
              ) {
                return false;
              }
              return true;
            }
          }
          return false;
        }),
        state.level3Filter.sort
      );
    },
    getListItemsLevel3All: state => {
      return state.listItemsLevel3;
    },
    getBoxItemsLevel3: state => {
      return state.boxItemsLevel3;
    },
    getLevel3Helper: state => {
      return state.level3Helper;
    },
    getCurrentbox: state => {
      return state.currentBox;
    },
    getLevel3Available: state => {
      return state.level3Available;
    },
    getLevel3NotAvailable: state => {
      return state.level3NotAvailable;
    },
    getLevel3Filter: state => {
      return state.level3Filter;
    },
    getIdToIdx: state => {
      return state.productIdToIdx;
    }
  },
  mutations: {
    setListItemsLevel3(state, items) {
      state.productIdToIdx = {};
      items.forEach((i, idx) => {
        state.productIdToIdx[i.id] = idx;
      });

      state.listItemsLevel3 = items;
    },
    setBoxItemsLevel3(state, boxes) {
      state.boxItemsLevel3 = boxes;
    },
    setLevel3Helper(state, helper) {
      state.level3Helper = helper;
    },
    setLevel3HelperIndex(state, index, value) {
      Vue.set(state.level3Helper, index, value);
    },
    setCurrentBox(state, box) {
      state.currentBox = box;
    },
    setLevel3Available(state, value) {
      state.level3Available = value;
    },
    setLevel3NotAvailable(state, value) {
      state.level3NotAvailable = value;
    },
    addLevel3FilterBrand(state, brand) {
      state.level3Filter.brands.push(brand);
    },
    removeLevel3FilterBrand(state, brand) {
      const newBrands = [];
      state.level3Filter.brands.forEach(b => {
        if (b !== brand) {
          newBrands.push(b);
        }
      });
      state.level3Filter.brands = newBrands;
    },
    clearLevel3FilterBrand(state) {
      state.level3Filter.brands = [];
    },
    setLevel3FilterMinPrice(state, price) {
      state.level3Filter.priceMin = price;
    },
    setLevel3FilterMaxPrice(state, price) {
      state.level3Filter.priceMax = price;
    },
    addLevel3FilterAttribute(state, attribute) {
      state.level3Filter.attributes.push(attribute);
    },
    removeLevel3FilterAttribute(state, attribute) {
      const newAttributes = [];
      state.level3Filter.attributes.forEach(a => {
        if (a !== attribute) {
          newAttributes.push(a);
        }
      });
      state.level3Filter.attributes = newAttributes;
    },
    clearLevel3FilterAttribute(state) {
      state.level3Filter.attributes = [];
    },
    setLevel3FilterFreeSearch(state, search) {
      state.level3Filter.freeSearch = search;
    },
    setLevel3FilterAdminDate(state, search) {
      state.level3Filter.adminDate = search;
    },
    setLevel3FilterAdminQty(state, search) {
      state.level3Filter.adminQty = search;
    },
    setLevel3FilterSort(state, sort) {
      state.level3Filter.sort = sort;
    },
    setLevel3FilterB2bQty(state, qty) {
      state.level3Filter.b2b.qty = qty;
    },
    setLevel3FilterB2bTime(state, time) {
      state.level3Filter.b2b.time = time;
    },
    clearLevel3FilterB2b(state) {
      state.level3Filter.b2b = { qty: 0, time: -1 };
    },
    setLevel3FilterUseB2cPrices(state, value) {
      state.level3Filter.useB2cPrices = value;
    },
    addLevel3FilterCategory(state, category) {
      state.level3Filter.categories.push(category);
    },
    removeLevel3FilterCategory(state, category) {
      const newCategories = [];
      state.level3Filter.categories.forEach(c => {
        if (c !== category) {
          newCategories.push(c);
        }
      });
      state.level3Filter.categories = newCategories;
    },
    clearLevel3FilterCategory(state) {
      state.level3Filter.categories = [];
    }
  }
};
